import React, {Component} from "react"
import {Row, Col} from "react-bootstrap"
import {RouteComponentProps, withRouter, Redirect} from "react-router-dom"
import id from "@irati/utils/id"
import {walletTracking} from "@irati-tracking/wallet"
import authentication from "@irati/auth"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Card as LinkedCard, PaymentCurrencyType, User, Wallet, WalletEntityType} from "@irati/types"
import history from "@irati/utils/history"
import walletService from "@irati/wallet/graph/wallet"
import linkedCardService from "@irati/perksgo/services/linkedcards"
import {PartialRoute} from "@irati/utils/history/routing"
import Loading from "@irati/ui/src/Loading"

import Intro from "../../components/Intro"
import WalletBalanceCard from "../../components/WalletBalanceCard"
import {CashTransactions, FlexiPointsTransactions, RewardPointsTransactions} from "../../components/Transactions"
import FAQs from "../../components/FAQs"
import SendCreditSuccessModal from "../../components/SendCreditSuccessModal"
import Container from "../styled/Container"
import {TabTypes} from "../../enums"

interface Props extends InjectIntl, RouteComponentProps<{}, {}, {recipient?: User, amount?: number}> {
  setCurrency: (currency: PaymentCurrencyType) => void,
  wallet: Wallet,
  tokenWallet: Wallet,
  rewardWallet: Wallet
}

interface State {
  selectedTab: TabTypes,
  wallet: Wallet,
  tokenWallet: Wallet,
  rewardWallet: Wallet,
  load?: Promise<any> | null,
  linkedCards?: LinkedCard[]
}

class WalletContainer extends Component<Props, State> {
  state: State = {
    selectedTab: TabTypes.Cleared,
    wallet: {},
    tokenWallet: {},
    rewardWallet: {},
    linkedCards: []
  }

  fetchData() {
    const requests = []
    const userId = authentication.user().uuid!
    if (authentication.apps("wallet.users")) {
      requests.push(walletService.get(userId, PaymentCurrencyType.Gbp, WalletEntityType.User, {fetchPolicy: "network-only"}
      ).then((wallet) => this.setState({wallet})))
    }
    if (authentication.apps("wallet.treatTokens")) {
      requests.push(walletService.get(userId, PaymentCurrencyType.Tt, WalletEntityType.User, {fetchPolicy: "network-only"}
      ).then((tokenWallet) => this.setState({tokenWallet})))
    }
    if(authentication.apps("wallet.flexiRewards")) {
      requests.push(walletService.get(userId, PaymentCurrencyType.Rp, WalletEntityType.User, {fetchPolicy: "network-only"}
      ).then((rewardWallet) => this.setState({rewardWallet})))
    }

    requests.push(linkedCardService.getPerksGOCards({userId}).then((linkedCards) => {
      this.setState({linkedCards})
    }))

    this.setState({load: Promise.all(requests)})
  }

  componentDidMount() {
    this.fetchData()
    walletTracking.viewHome()
  }

  handleCloseModal = () => {
    // replace current url without state which drives showing popup
    const currentUrl = this.props.location.pathname
    history.replace(currentUrl)
  }

  handleTabChange = (selectedTab: TabTypes) => {
    this.setState({selectedTab})
  }

  render() {
    const {selectedTab, wallet, tokenWallet, rewardWallet, linkedCards, load} = this.state
    const idNamespace = id("wallet", this.props, {force: true})
    const hasLinkedCards = linkedCards && linkedCards.length > 0
    const {recipient, amount} = this.props.location.state || {}

    return (
      <Container>
        <Loading load={load}>
          <Row>
            <Col md={6} lg={12}>
              <Intro id={idNamespace} wallet={wallet} />
            </Col>
          </Row>

          <WalletBalanceCard
            id={idNamespace}
            wallet={wallet}
            tokenWallet={tokenWallet}
            rewardWallet={rewardWallet} />

          <PartialRoute
            match={this.props.match.path}
            path="/flexi-points"
            component={FlexiPointsTransactions}
            componentProps={{wallet: tokenWallet, id: idNamespace}} />
          <PartialRoute
            match={this.props.match.path}
            path="/reward-points"
            component={RewardPointsTransactions}
            componentProps={{wallet: rewardWallet}} />
          <PartialRoute
            match={this.props.match.path}
            path="/cash"
            component={CashTransactions}
            componentProps={{wallet, id: idNamespace, selectedTab, onTabChange: this.handleTabChange}} />
          <PartialRoute
            exact
            match={this.props.match.path}
            path="/"
            component={() => <Redirect to="/wallet/flexi-points" />} />

          {hasLinkedCards && <Row>
            <Col md={12}>
              <FAQs id={idNamespace} selectedTab={selectedTab} />
            </Col>
          </Row>}
          {!!recipient && <SendCreditSuccessModal recipient={recipient} value={amount} onClose={this.handleCloseModal} />}
        </Loading>
      </Container>
    )
  }
}

export default injectIntl((withRouter(WalletContainer)))
